import React from 'react';
import SectionWrapper from '../layout/SectionWrapper';

/**
 * Specialized component for rendering professional affiliations
 * Simple list format with consistent styling
 */
const AffiliationsList = ({ 
  affiliations, 
  title = 'Professional Affiliations',
  titleTag = 'h4'
}) => {
  if (!affiliations || !affiliations.length) return null;

  return (
    <SectionWrapper title={title} titleTag={titleTag}>
      <ul>
        {affiliations.map((affiliation, index) => (
          <li key={index}>{affiliation}</li>
        ))}
      </ul>
    </SectionWrapper>
  );
};

export default AffiliationsList;